// extracted by mini-css-extract-plugin
export var markdown = "_vk-0";
export var tableWrapper = "_vk-1";